import Acc1 from '../imgAcc/accueil1.avif'
import Acc2 from '../imgAcc/accueil2.avif'
import Acc3 from '../imgAcc/accueil3.avif'



export const carouselImg=[{url:Acc1}, {url: Acc2}, {url:Acc3}];


